import { assetApi } from './assetApiBase';
import { AssetListView } from './types/assetTypes';
import { RecurringTaskView } from '../RecurringTaskService';

// `getAssetById`, `getAssets`, and `listAssetDocuments` now live on the base `assetApi` instance
// itself (T059 — its shell is `@trackly/shared`'s `createAssetApi`), so they are not
// re-injected here; the destructured export below still carries them through unchanged, since
// `injectEndpoints` mutates and returns the same underlying object.
export const assetQueriesApi = assetApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get active assets only
    getActiveAssets: builder.query<AssetListView[], void>({
      query: () => ({
        url: 'Assets',
        params: { status: 'ACTV' },
      }),
      providesTags: ['AssetList'],
    }),

    // Get recurring tasks linked to an asset
    getAssetRecurringTasks: builder.query<RecurringTaskView[], string>({
      query: (assetId) => ({
        url: `Assets/recurring-tasks`,
        params: { assetId },
      }),
      providesTags: (result, error, id) => [{ type: 'Asset', id }],
    }),

    // View a document (for inline viewing)
    viewAssetDocument: builder.query<Blob, { assetId: string; documentId: string }>({
      query: ({ assetId, documentId }) => ({
        url: `assets/${assetId}/documents/${documentId}/view`,
        method: 'GET',
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetAssetByIdQuery,
  useGetAssetsQuery,
  useGetActiveAssetsQuery,
  useGetAssetCostsQuery,
  useGetAssetRecurringTasksQuery,
  useListAssetDocumentsQuery,
  useViewAssetDocumentQuery,
} = assetQueriesApi;

